
import { defineComponent } from 'vue'
import PublicSearchResult from '@/components/organisms/dms/PublicSearchResult/PublicSearchResult.vue'
export default defineComponent({
  components: {
    PublicSearchResult,
  },
})
